import { useEffect, useMemo, useState } from 'react';
import ModelsAPI from '../api/models';
import { ProviderDefinition } from '../api/structs/providers';

/**
 * Which of `extra` (providers beyond the usual list, e.g. Anthropic's own,
 * which only a server with its key serves) to offer: those the chat catalog
 * has a model of, plus the one already `selected`, so a saved choice stays
 * visible and explainable. Nothing is fetched without `extra`; a catalog that
 * cannot be read offers none.
 */
export function useOfferedProviders(extra: ProviderDefinition[] | undefined, selected: string): ProviderDefinition[] {
  const [served, setServed] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!extra || extra.length === 0) return undefined;
    let cancelled = false;
    void ModelsAPI.getChatModels()
      .then((models) => {
        if (!cancelled) setServed(new Set((models ?? []).map((model) => model.provider)));
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [extra]);

  // Memoized: the selector derives effect dependencies from the list.
  return useMemo(
    () => (extra ?? []).filter((item) => item.value === selected || served.has(item.value)),
    [extra, selected, served]
  );
}

export default useOfferedProviders;
